import React from 'react';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import PropTypes from 'prop-types';
import {ThemeContext} from '../';

const tabProps = {className: 'tab-component__item', selectedClassName: 'tab-component__item_active'};

const renderTabs = ({title}, {primaryColor}) => (
  <Tab key={`tab_${title}`} {...tabProps} style={{background: primaryColor}}>{title}</Tab>
);

const renderPanels = ({title, children}) => <TabPanel key={`pane_${title}`}>{children}</TabPanel>;

const TabComponent = ({tabs, onSelectTab}) => (
  <ThemeContext.Consumer>
    {template => (
      <Tabs onSelect={onSelectTab}>
        <TabList className="tab-component">
          {tabs.map(tab => renderTabs(tab, template))}
        </TabList>
        {tabs.map(renderPanels)}
      </Tabs>
    )}
  </ThemeContext.Consumer>

);

renderTabs.propTypes = {
  title: PropTypes.string.isRequired,
};

renderPanels.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.shape({}).isRequired,
};

TabComponent.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onSelectTab: PropTypes.func,
};

export default TabComponent;
